import React from 'react'
import Blogmainsection from './blogmainsection'
import Blogsidesection from './blogsidesection'

const Blogspages = () => {
  return (
    <div className='2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 mt-20 mb-10'>
    <div className='grid grid-cols-1 lg:grid-cols-12 gap-8'>
     <div className='col-span-1 lg:col-span-9'>
      <Blogmainsection/>
     </div>
     <div className='col-span-1 lg:col-span-3'>
     <Blogsidesection/>
     </div>
    </div>
    </div>
  )
}

export default Blogspages